export enum UserType {
	Reader = 1,
	Contributor,
	Manager,
	Administrator
}

export enum EditPermissions {
	EditNotAllowed = 0,
	CanEditCustomer = 1 << 0,
	CanEditPartner = 1 << 1,
	CanEditOrgUrl = 1 << 2,
	Full = ~(~0 << 8)
}

export interface IUserPermissions {
	canEdit: boolean;
	canView?: boolean;
	canCreate?: boolean;
	canDelete?: boolean;
	canExportData? : boolean;
	editPermissions: EditPermissions;
	maxTrialExtendInDays?: number;
}

export interface IUserRole {
	permissions: IUserPermissions;
	type: UserType;
	label: string;
	isAdmin?: boolean;
}

export interface IUserInfo extends IUserRole {
	userName?: string;
	userFullName?: string;
}

export const UserRoles: { [id: string]: IUserRole } = {
	Reader: { label: "Support", type: UserType.Reader, permissions: { canView: true, canEdit: false, maxTrialExtendInDays: 0, editPermissions: EditPermissions.EditNotAllowed } },
	Contributor: { label: "Sales Person", type: UserType.Contributor, permissions: { canView: true, canEdit: true, canCreate: true, canDelete: true, canExportData: true, maxTrialExtendInDays: 92, editPermissions: EditPermissions.Full } },
	Manager: { label: "Sales Manager", type: UserType.Manager, permissions: { canView: true, canEdit: true, canCreate: true, canDelete: true, canExportData: true, editPermissions: EditPermissions.Full } },
	Administrator: { label: "Administrator", type: UserType.Administrator, permissions: { canView: true, canEdit: true, canCreate: true, canDelete: true, canExportData: true, editPermissions: EditPermissions.Full }, isAdmin: true }
}
